import { IOfferScopePageLang } from '../../../types/lang'

export const offerScopePageLang: IOfferScopePageLang = {
	offer_scope_page: {
		notification_unscoped_offers_count: '{{cnt}} offers',
		notification_unscoped_offers_title: 'are unscoped',
		btn_add_new: 'Add New',
	}
}